<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          ref="ruleForm"
        >
        <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{$t('companies.group_company_data')}}</h2>
        <div class="lg:max-w-detail lg:mr-auto" v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
        <div class="lg:mb-2" >
              <div class="flex justify-between items-center">
                <div class="w-full">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="true"
                    id-prefix="company"
                  >
                    <template slot="label">{{$t('app.client')}}</template>
                  </AccessibleElSelect>
                </div>
                <base-button class="ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
          </div>
            </div>
        <div class="lg:max-w-detail lg:mr-auto">
          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.companyName')}}
                <el-form-item prop="NombreCIF">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.NombreCIF"
                    maxlength='150'
                  />
                </el-form-item>
              </label>
            </div>
          </div>
          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}
                <el-form-item prop="CIF">
                  <el-input
                    disabled
                    clearable
                    class="w-full"
                    v-model="form.CIF"
                    maxlength='50'
                  />
                </el-form-item>
              </label>
            </div>
          </div>
          <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.cod_ext')}}
                  <el-form-item prop="CodigoExt">
                    <el-input
                      clearable
                      class="w-full"
                      disabled
                      v-model="form.CodigoExt"
                      maxlength='20'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
          <div class="lg:mb-4">
              <label for="switch-company-status" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('companies.status')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('configurations.active')}}</span>
              </label>
              <el-switch 
                id="switch-company-status"
                :aria-label="$t('companies.status')"
                class="switch-text break-normal mt-2" 
                disabled 
                v-model="form.Activo" 
                :active-text="$t('configurations.active')">
              </el-switch>
          </div>

        <!-- <h2 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('companies.group_alert')}}</h2> -->

        <base-collapsible-form 
          ref="baseCollapsibleAlerts" 
          class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
          <template slot="headerRight">
            <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.group_alert')}}</h2>
          </template>
          <template slot="content">

             <div class="mt-2 mb-4">
              <label for="switch-group-alert-active" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('companies.group_alert_active')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="switch-group-alert-active"
                :aria-label="$t('companies.group_alert_active')"
                class="switch-text break-normal mt-2" 
                disabled
                v-model="form.EnviarAvisos"
                :active-text="$t('companies.active')">
              </el-switch>
            </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_alerts')}}
                    <el-form-item prop="EmailAvisoNueva">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoNueva"
                        maxlength='500'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_downloads')}}
                    <el-form-item prop="EmailAvisoDescargada">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoDescargada"
                        maxlength='500'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2" v-if="hasPermModuleSMS">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.sms_downloads')}}
                    <el-form-item prop="SMSAvisoDescargada">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        maxlength="9"
                        v-model="form.SMSAvisoDescargada"
                      >
                        <template slot="prepend">+34</template>
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
              </div>
              
              <div class="lg:mb-0">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.download_alert_days_form')}}
                      <el-form-item prop="DiasAviso" class="mb-0">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model.number="form.DiasAviso"
                          maxlength='5'
                          :placeholder="$t('configurations.default_disabled')"
                        />
                      </el-form-item>
                    </label>
                  </div>
                  <div class="px-2 w-full lg:mb-0">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.end_alert_days_label_form')}}
                      <el-form-item prop="DiasAvisoFinTramite" class="mb-0">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model.number="form.DiasAvisoFinTramite"
                          maxlength='5'
                          :placeholder="$t('configurations.default_disabled')"
                        />
                      </el-form-item>
                    </label>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mt-5 mb-5 mr-20">
                  <label for="switch-mails-group-status" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('configurations.mails_group_status')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-mails-group-status"
                    :aria-label="$t('configurations.mails_group_status')"
                    class="switch-text break-normal mt-2" 
                    disabled
                    v-model="form.AgruparEmailsAvisos"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label v-if="form.AgruparEmailsAvisos" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.mails_group_status_input')}}</label>
                  <label v-else class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_ultima_llamada')}}</label>
                  <el-form-item prop="EmailAvisoUltimaLlamada">
                    <el-input
                      disabled
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoUltimaLlamada"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
              </div> 
              <div class="lg:mb-2" v-if="form.AgruparEmailsAvisos === false">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tramitacion_urgente')}}
                    <el-form-item prop="EmailAvisoTramitacionUrgente">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoTramitacionUrgente"
                        maxlength='500'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
              <div class="lg:mb-2" v-if="form.AgruparEmailsAvisos === false">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_neos_error')}}
                    <el-form-item prop="EmailAvisoErrores">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.EmailAvisoErrores"
                        maxlength='500'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tech')}}
                    <el-form-item prop="EmailTecnico">
                      <el-input
                        disabled
                        clearable
                        class="w-full"
                        v-model="form.EmailTecnico"
                        maxlength='500'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>

          </template>
        </base-collapsible-form>
         
          <!-- <h2 class="dark:text-darkblue-200 font-bold mt-8 mb-4">{{$t('companies.automatic_download')}}</h2> -->

          <base-collapsible-form 
            ref="baseCollapsibleAutoDownload"
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.automatic_download')}}</h2>
            </template>
            <template slot="content">

               <div class="lg:mb-2">
                <div class="mt-2 mb-5 mr-20">
                  <label for="switch-automatic-download" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                    {{$t('companies.automatic_download_active')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="switch-automatic-download"
                    :aria-label="$t('companies.automatic_download_active')"
                    class="switch-text break-normal mt-2" 
                    disabled
                    v-model="form.DescargaAutomatica"
                    :active-text="$t('companies.active')">
                  </el-switch>
                </div>
              </div>
              <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.automatic_download_days_label')}}
                      <el-form-item prop="DiasDescargaAutomatica">
                        <el-input
                          disabled
                          clearable
                          class="w-full"
                          v-model.number="form.DiasDescargaAutomatica"
                          maxlength='5'
                        />
                      </el-form-item>
                    </label>
                  </div>
              </div>

            </template>
          </base-collapsible-form>

        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="trash"
            @click="deleteCompany()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="restore"
            @click="restoreCompany()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
            title="Borrar empresa"
            :visible.sync="showModal"
            @open="handleOpenModalDialog('container-handleOpenModal-delete-company')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-company">
                <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
              </div>
            </template> 
      </BaseElDialog>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getCompany } from '@/services/companies/getCompany'
// import { getCertificateFromCif } from '@/services/companies/getCertificateFromCif'
import { getClients } from '@/services/clients/getClients'
import moment from 'moment'
// import { i18n } from '@/i18n'
import { deleteTrashCompany } from '@/services/trash/deleteTrashCompany'
import { restoreTrashCompany } from '@/services/trash/restoreTrashCompany'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-empresa',
  components: {
    DetailLayoutFullWidth,
    BaseElDialog,
    AccessibleElSelect
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      vuexnamespace: 'companies',
      clientes: [],
      header: {
        title: 'DETALLE DE EMPRESA BORRADA',
        icon: 'companies',
        breadcrumb: {},
        nav: [],
        url: 'trash/companies'
      },
      form: {
        IdCIFEmpresa: 0,
        IdEmpresa: 0,
        CIF: '',
        NombreCIF: '',
        EmailAvisoNueva: '',
        EmailAvisoDescargada: '',
        SMSAvisoDescargada: '',
        DescargaAutomatica: true,
        DiasDescargaAutomatica: 0,
        Activo: true,
        DiasAviso: 0,
        DiasAvisoFinTramite: 0,
        AgruparEmailsAvisos: false,
        EmailAvisoUltimaLlamada: '',
        EmailAvisoTramitacionUrgente: '',
        EmailAvisoErrores: '',
        EmailTecnico: '',
        FechaAlta: '',
        FechaBaja: '',
        CodigoExt: '',
        clienteId: null,
        EnviarAvisos: true
      },
      certificate: null,
      showModal: false,
      processMessageDelete: '¿Estás seguro que deseas borrar permanente la empresa?',
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        name: cliente.Nombre,
        value: cliente.IdEmpresa
      }))
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: async function () {
    const companyId = this.$route.params.id
    const breadcrumbs = []
    
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
    }

    await this.downloadCompanyData(companyId)
    breadcrumbs.push({ path: 'trash/companies', name: this.$i18n.t('app.trash') })
    breadcrumbs.push({ path: 'trash/companies', name: this.$i18n.t('trash.companies') })
    breadcrumbs.push({ path: '', name: this.form.NombreCIF })
    this.$store.commit('app/setheaderBreadCrumb', this.form.NombreCIF)
    
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteCompany () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idCifsEmpresa: []
        }
        payload.idCifsEmpresa.push(this.id)
        const response = await deleteTrashCompany(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreCompany: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          idCifsEmpresa: []
        }
        payload.idCifsEmpresa.push(this.id)
        const response = await restoreTrashCompany(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    watchFormHandler: function ({ certificate, send_alerts, automatic_download }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (automatic_download !== undefined) {
        this.form.automatic_download = !!automatic_download
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    goBack: function () {
      this.$router.push({ name: 'trash/companies' })
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          IdCIFEmpresa: companyId,
          borrado: true,
        }
        const company = await getCompany(params)
        if (company.blnError === true) {
          this.doFeedback(company.msgError + ' [Código de error: ' + company.codError + ']')
        } else {
          this.setCompany(company.CIFSEmpresa[0])
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCompany: function (company) {
      if (company) {
        this.form.NombreCIF = company.NombreCIF ? company.NombreCIF : null
        this.form.CIF = company.CIF ? company.CIF : null
        this.form.EmailAvisoNueva = company.EmailAvisoNueva ? company.EmailAvisoNueva : null
        this.form.EmailAvisoDescargada = company.EmailAvisoDescargada ? company.EmailAvisoDescargada : null
        this.form.SMSAvisoDescargada = company.NumeroSMSDescargadas ? company.NumeroSMSDescargadas.substring(4) : null
        this.form.EmailAvisoUltimaLlamada = company.EmailDiasAviso ? company.EmailDiasAviso : null
        this.form.EmailAvisoTramitacionUrgente = company.EmailAvisoTramitacionUrgente ? company.EmailAvisoTramitacionUrgente : null
        this.form.EmailAvisoErrores = company.EmailAvisoErrores ? company.EmailAvisoErrores : null
        this.form.AgruparEmailsAvisos = company.AgruparEmailsAvisos ? company.AgruparEmailsAvisos : false
        this.form.EmailTecnico = company.EmailTecnico ? company.EmailTecnico : null
        this.form.FechaAlta = company.FechaAlta ? company.FechaAlta : null
        this.form.FechaBaja = company.FechaBaja ? moment(company.FechaBaja).format('DD-MM-YYYY HH:mm') : null
        this.form.CodigoExt = company.CodigoExt ? company.CodigoExt : null
        this.form.DescargaAutomatica = company.DescargaAutomatica
        this.form.EnviarAvisos = company.EnviarAvisos
        this.form.DiasDescargaAutomatica = company.DiasDescargaAutomatica ? company.DiasDescargaAutomatica : 0
        this.form.Activo = company.Activo
        this.form.DiasAviso = company.DiasAviso ? company.DiasAviso : 0
        this.form.DiasAvisoFinTramite = company.DiasFinTramite ? company.DiasFinTramite : 0
        this.form.clienteId = company.IdEmpresa ? company.IdEmpresa : null
        this.form.CN = company.CN ? company.CN : null
      }
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

</style>

<style lang="sass" scoped>
</style>
